module.exports = __webpack_public_path__ + "static/media/logo.2f1f8dfe.svg";